import Accordion from './js/accordion'
import IPAdressFinder from './js/ip-finder'
import Scroller from './js/scroller'
import Sliders from './js/sliders'
import MobileNav from './js/mobile-nav'
import Video from './js/video-player'
import Gallery from './js/gallery'


window.onload = function() {
    if(document.querySelector('.ip-country-content')){
        new IPAdressFinder
    }
    if(document.querySelector('.wrm-accordion')){
        new Accordion
    }
   
    new Scroller
    
    if(document.querySelector('.mobile-navigation')){
        new MobileNav
    }
    if(document.querySelector('.showreel_wrapper')){
        new Video
    }
    if(document.querySelector('.splide')){
        new Sliders
    }
    if(document.querySelector('#lightgallery')){
        new Gallery
    }
}
